import qs from "qs";
import humps from "humps";

export function generateQueryString(queryParams) {
  return `?${qs.stringify(humps.decamelizeKeys(queryParams))}`;
}
